import { NetWorkApi } from "@/services/fetch";
import { API } from "@/services/swagger/resposeType";
import { UserInfoProps } from "../store";
import { USER_INFO } from "@/services/state";
import storageUtils from "./storageUtils";

export const clearUserLoginInfo = (isBack?:boolean) => {
  USER_INFO.isLogin = false;
  USER_INFO.platform = null;
  USER_INFO.githubName = null;
  USER_INFO.githubHeadImg = null;
  USER_INFO.wechatName = null;
  USER_INFO.wechatHeadImg = null;
  USER_INFO.qqName = null;
  USER_INFO.qqHeadImg = null;
  USER_INFO.role = null;
  USER_INFO.token = "";
  USER_INFO.user_id = 0;
  USER_INFO.checkPlugin = false;
  USER_INFO.companyName = null;
  USER_INFO.companyHeadImg = null;
  storageUtils.removeUserLoginInfo();
  if(isBack){
    window.location.href = "/";
  }
};

export const loginOut = async (userInfo: UserInfoProps) => {
  if (!userInfo.isLogin) return;
  return new Promise((resolve, reject) => {
    NetWorkApi<null, API.ActionSucceeded>({
      method: "get",
      url: "logout/online",
      headers: {
        Authorization: userInfo.token,
      },
    })
      .then((res: API.ActionSucceeded) => {})
      .catch(() => {})
      .finally(() => {
        clearUserLoginInfo(true);
        resolve(null);
      });
  });
};
